import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "className", "placeholder", "disabled", "error", "busy", "onChange", "onFocus", "onBlur", "onClear", "mode", "size", "theme", "type", "value", "icon", "iconType", "label", "note", "clearIcon", "suffix", "offSystemMicroelements", "style", "boldLabel"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from '@rescui/icons';
import cn from 'classnames';
import { useTheme } from '@rescui/ui-contexts';
import styles from './input.p.module.css.js';
import { RightIcons } from './parts/right-icons.js';
import { CustomIcon } from './parts/custom-icon.js';
var useEffect = React.useEffect,
    useRef = React.useRef,
    useState = React.useState;
var sizeStyles = {
  l: styles.sizeL,
  m: styles.sizeM,
  s: styles.sizeS
};
var Input = /*#__PURE__*/React.forwardRef( // eslint-disable-next-line complexity
function (_ref, ref) {
  var _cn;

  var id = _ref.id,
      className = _ref.className,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled,
      error = _ref.error,
      busy = _ref.busy,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onClear = _ref.onClear,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'classic' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      themeFromProps = _ref.theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      value = _ref.value,
      icon = _ref.icon,
      _ref$iconType = _ref.iconType,
      iconType = _ref$iconType === void 0 ? 'right' : _ref$iconType,
      label = _ref.label,
      note = _ref.note,
      _ref$clearIcon = _ref.clearIcon,
      clearIcon = _ref$clearIcon === void 0 ? /*#__PURE__*/React.createElement(CloseIcon, null) : _ref$clearIcon,
      suffix = _ref.suffix,
      offSystemMicroelements = _ref.offSystemMicroelements,
      style = _ref.style,
      boldLabel = _ref.boldLabel,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme(themeFromProps); // replace with :focus-within when ie11 is not supported anymore

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var empty = !value;
  var filled = !empty;
  var enabled = !disabled;
  var inputMouseDown = useRef(false);
  var activeRef = useRef(false); // run effect only on unmount with final props

  var unmountPropsRef = useRef({});
  unmountPropsRef.current = {
    type: type,
    onChange: onChange
  };
  useEffect(function () {
    return function () {
      if (unmountPropsRef.current.type === 'file' && unmountPropsRef.current.onChange) {
        unmountPropsRef.current.onChange({
          target: {
            type: 'file',
            files: null
          }
        });
      }
    };
  }, []);
  var renderLeftCustomIcon = icon && iconType === 'left';
  var renderRightCustomIcon = icon && (iconType === 'right' || iconType === 'rightAction' || iconType === 'rightActionFocusable');
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.container, styles[theme], styles[mode], sizeStyles[size], (_cn = {}, _defineProperty(_cn, styles.focused, focused), _defineProperty(_cn, styles.filled, filled), _defineProperty(_cn, styles.enabled, enabled), _defineProperty(_cn, styles.error, Boolean(error)), _defineProperty(_cn, styles.disabled, disabled), _defineProperty(_cn, styles.offSystemMicroelements, offSystemMicroelements), _defineProperty(_cn, styles.boldLabel, boldLabel), _cn), className),
    style: style,
    "data-test": "input"
  }, /*#__PURE__*/React.createElement("label", null, label && /*#__PURE__*/React.createElement("div", {
    className: styles.label
  }, label), /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper,
    onFocus: function onFocus() {
      setFocused(true);
    },
    onMouseUp: function onMouseUp() {
      if (activeRef.current) {
        setFocused(false);
      }

      activeRef.current = false;
    },
    onMouseDown: function onMouseDown() {
      if (inputMouseDown.current) {
        inputMouseDown.current = false;
        return;
      }

      activeRef.current = true;
    },
    onMouseLeave: function onMouseLeave() {
      if (activeRef.current) {
        setFocused(false);
      }

      activeRef.current = false;
    },
    onBlur: function onBlur() {
      if (!activeRef.current) {
        setFocused(false);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.field
  }, renderLeftCustomIcon && /*#__PURE__*/React.createElement(CustomIcon, {
    icon: icon,
    iconIsAction: false,
    iconIsFocusable: false,
    iconPosition: "left",
    size: size
  }), /*#__PURE__*/React.createElement("input", _objectSpread(_objectSpread({}, restProps), {}, {
    id: id,
    className: styles.inner,
    type: type,
    disabled: disabled,
    placeholder: placeholder,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onMouseDown: function onMouseDown(e) {
      inputMouseDown.current = true;

      if (restProps.onMouseDown) {
        restProps.onMouseDown(e);
      }
    },
    value: value,
    ref: ref,
    "aria-invalid": Boolean(error),
    "data-test": "input__inner"
  })), /*#__PURE__*/React.createElement(RightIcons, {
    icon: renderRightCustomIcon && icon,
    iconIsAction: iconType === 'rightAction' || iconType === 'rightActionFocusable',
    iconIsFocusable: iconType === 'rightActionFocusable',
    size: size,
    clearIcon: clearIcon,
    onClear: onClear,
    empty: empty,
    busy: busy
  })), suffix && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: styles.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.suffix,
    "data-test": "input__suffix"
  }, suffix)))), error && typeof error !== 'boolean' && /*#__PURE__*/React.createElement("div", {
    className: styles.errorMessage,
    "data-test": "input__error-message"
  }, error), note && /*#__PURE__*/React.createElement("div", {
    className: styles.note
  }, note));
});
Input.displayName = 'Input';
Input.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),
  busy: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClear: PropTypes.func,
  mode: PropTypes.oneOf(['classic', 'rock']),
  size: PropTypes.oneOf(['s', 'm', 'l']),
  theme: PropTypes.oneOf(['light', 'dark']),
  type: PropTypes.oneOf(['text', 'email', 'search', 'date', 'time', 'password', 'number', 'file', 'url', 'tel']),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
  icon: PropTypes.node,
  iconType: PropTypes.oneOf(['left', 'right', 'rightAction', 'rightActionFocusable']),
  label: PropTypes.node,
  note: PropTypes.node,
  clearIcon: PropTypes.node,
  suffix: PropTypes.node,
  offSystemMicroelements: PropTypes.bool
};
Input.displayName = 'Input';
export { Input, Input as default };
